function etxLazyLoad() {
  // console.log("etxLazyLoad");
  return new Promise((resolve) => {
    const lazyEls = document.querySelectorAll('.lazy');
    let remaining = lazyEls.length;

    if (remaining === 0) {
      resolve();
      return;
    }

    const onLoaded = () => {
      remaining--;
      if (remaining === 0) resolve();
    };

    const setIfData = (el, attr, ...dataKeys) => {
      for (const k of dataKeys) {
        const v = el.dataset[k];
        if (v) {
          el.setAttribute(attr, v);
          return true;
        }
      }
      return false;
    };

    const loadEl = (el) => {
      const tag = el.tagName.toLowerCase();
      let img;

      if (tag === 'div') {
        const src = el.dataset.src;
        if (src) el.style.backgroundImage = `url('${src}')`;
        onLoaded();
      } else if (tag === 'img') {
        img = el;
        setIfData(img, 'srcset', 'srcset');
        setIfData(img, 'src', 'src');
      } else if (tag === 'picture') {
        el.querySelectorAll('source').forEach((s) => {
          setIfData(s, 'srcset', 'srcset', 'src');
        });
        img = el.querySelector('img');
        if (img) {
          setIfData(img, 'srcset', 'srcset');
          setIfData(img, 'src', 'src');
        }
      }

      if (img) {
        img.onload = onLoaded;
        img.onerror = onLoaded;
      }
      el.classList.remove('lazy');
    };

    lazyEls.forEach(loadEl);
  });
}
